export const ROLE_LABELS: Record<string, string> = {
    dom: 'Dominant',
    sub: 'Submissive',
    switch: 'Switch',
};

export const ROLE_BADGE_COLORS: Record<string, string> = {
    dom: 'bg-red-500/20 text-red-400',
    sub: 'bg-violet-500/20 text-violet-400',
    switch: 'bg-amber-500/20 text-amber-400',
};

export function getRoleLabel(role: string): string {
    return ROLE_LABELS[role] ?? role;
}

export function getRoleBadgeColor(role: string): string {
    return ROLE_BADGE_COLORS[role] ?? 'bg-slate-700 text-slate-300';
}
